export const forgotPasswordInitialValues = {
  email: '',
};

export type ForgotPasswordFormikValues = typeof forgotPasswordInitialValues;

export const generateResetPasswordInitialValues = (email?: string) => {
  return {
    email: email ?? '',
    PASSWORD: '',
    PASSWORD_CONFIRM: '',
  };
};

export type ResetPasswordFormikValues = ReturnType<typeof generateResetPasswordInitialValues>;
